import { Component, HostListener, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { FooterComponent } from '../footer/footer.component';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    CommonModule,
    MatProgressSpinnerModule
  ],
  standalone: true
})
export class LayoutComponent implements OnInit {
  showFooter: boolean = true;
  isResponsive: boolean = false;
  scrolled: boolean = false;
  showLoading: boolean = true;
  isReasonPage: boolean = false;
  private commonService = inject(CommonService);

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.showFooter = !(event.url === '/metodologia');
      }
      this.isReasonPage = this.router.url.includes('/motivo');
    });
    this.validateRoute();
    this.commonService.loading.subscribe((value) => {
      this.showLoading = value;
    });
  }

  ngDoCheck() {
    this.checkScreenSize();
  }

  validateRoute() {
    if (this.router.url.includes('/metodologia')) {
      this.showFooter = false;
    }
    if (this.router.url.includes('/motivo')) {
      this.isReasonPage = true;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.scrolled = window.scrollY > 0;
  }

  @HostListener('window:resize', [])
  onResize() {
    this.checkScreenSize();
  }

  checkScreenSize() {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      return;
    }
    const width = window.innerWidth;
    this.isResponsive = width <= 992;
  }
}
